module.exports = __webpack_public_path__ + "static/media/20-12.a8a24032.mp3";